<template>
  <div>
    <div v-if="!selectorOpen" class="form-group">
      <button class="btn btn btn-light text-left w-100" 
              title="Click to edit" 
              @click="selectorOpen = true">
        {{ description || emptyValue }}
      </button>
    </div>
    <div v-if="selectorOpen" class="">
      <div class="form-group">
        <div class="input-group">
          <InputText id="propertyPostcode" v-model="postcode" @keypress.enter="lookupAddresses()" :placeholder="postcodePlaceholder" class="ww-100" />
          <button class="btn btn-sm btn-secondary" @click.prevent="lookupAddresses()"><i class="fas fa-search"></i></button>
        </div>
      </div>
      <div class="form-group">
        <b-overlay :show="searching">
          <Dropdown id="propertyAddress" :disabled="addresses.length === 0" showClear class="w-100" v-model="address" :placeholder="addressPlaceholder" :options="addresses" optionLabel="summaryline"></Dropdown>
        </b-overlay>
      </div>
      <div class="text-right">
        <button class="btn btn-sm btn-ghost-secondary mr-2" 
                @click="cancel()">
          {{ cancelLabel }}
        </button>
        <button class="btn btn-sm btn-ghost-success"
                @click.prevent="ok()">
          {{ okLabel }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {PostcoderApi} from "@/services/PostcodeApi";
import InputText from "primevue/inputtext"
import Dropdown from "primevue/dropdown"

export default {
  name: "PostcodePicker",
  
  components: {
    InputText,
    Dropdown
  },

  props: {
    description: {
      type: String,
      default: null
    },
    value: Object,
    emptyValue: {
      type: String,
      default: "Click to edit..."
    },
    postcodePlaceholder: {
      type: String,
      default: "AB1 2CD"
    },
    addressPlaceholder: {
      type: String,
      default: "..."
    },
    cancelLabel: {
      type: String,
      default: "Cancel"
    },
    okLabel: {
      type: String,
      default: "OK"
    }
  },
  
  data() {
    return {
      postcode: null,
      searching: false,
      address: null,
      addresses: [],
      selectorOpen: false
    }
  },

  methods: {
    lookupAddresses() {
      if (this.postcode != null) {
        this.searching = true;
        let client = new PostcoderApi("PCWMV-HJ7SZ-HM7YQ-5WP3A");
        client.lookupByPostcode(this.postcode)
            .then(addresses => {
              this.addresses = addresses
              this.searching = false;
            })
            .catch(error => {
              console.log(error);
              this.searching = false;
            });
      }
    },

    cancel() {
      this.selectorOpen = false;
    },

    ok() {
      if (this.address != null) {
        this.$emit("input", this.address); // Vue2
        //this.$emit("update", this.address); // Vue3
        this.selectorOpen = false;
      }
    },
  }

}
</script>

<style scoped>

</style>